module.exports = __webpack_public_path__ + "static/media/cloud.95f67a74.jpg";